import React from 'react';
import Routes from './routing/app';
import { ToastContainer } from 'react-toastify';
import { Provider } from 'react-redux';
import store from './config/store';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
// import "bootstrap/less/bootstrap.less";
import "react-datepicker/dist/react-datepicker.css";
// import Design from './design';
// import '@fullcalendar/core/main.css';
import '@fullcalendar/daygrid/main.css';

function App() {
	console.error = console.warn = () => {};
	return (
		<Provider store={store}>
			<ToastContainer	/>
			<Routes />
		</Provider>
		// <Design />
	);
}

export default App;
